var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-10"},[_vm._v(_vm._s(_vm.username))]),_c('tab-container',{staticClass:"sm:pb-16"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }